import { useCallback, useEffect, useMemo, useState, useContext } from "react";
import { ManageApis } from "../../common/APIS/ManageApis";
import { ContextAPI } from "../../common/Context/ContextApi";
import { Skeleton, Spin, Table } from "@arco-design/web-react";
import BranchList from "../../Components/BranchList/BranchList";
import {
  FailedPopup,
  convertToLakhOrCrore,
  customLogger,
  preventFirstLetterZero,
  preventSpecialCharsandNum,
  successPopup,
} from "../../common/Utils/Utils";
import PopupModal from "../../Components/PopupModal";
import InputField from "../../Components/InputField/InputField";
import GeneralButton from "../../Components/Buttons/GeneralButton";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const initialValue = {
  chit_no: "",
  branch_id: "",
  branch_name: "",
  pattern: "",
  message: "Want to know more about this",
};
const initialFormValue = {
  sala: "",
  noOfInstallments: "",
  chit_no: "",
  branch_id: "",
  branch_name: "",
  district: "",
  pattern: "",
  denomination: "",
  message: "Want to know more about this",
};

function NewChits() {
  const [visible, setVisible] = useState(false);
  const [Errors, setErrors] = useState({});
  const { token } = useContext(ContextAPI);
  const [list, setList] = useState([]);
  const [loader, setloader] = useState(false);
  const [form, setform] = useState(initialValue);
  const [searchForm, setSearchform] = useState(initialFormValue);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [checked, setChecked] = useState(false);
  const [searchInputvalue, setSearchInputvalue] = useState("");

  const districts = useMemo(() => {
    return districtList.map((itm) => ({ value: itm.name, key: itm.name }));
  }, [districtList]);

  const location = useLocation();
  const state = location.state;
  const is_unregister_user = state?.is_unregister_user;

  const quickToken = localStorage.getItem("quickToken") || "";

  const toggleCheckbox = () => {
    setChecked((prev) => !prev);
  };
  const handleOpenModal = (item) => {
    setVisible(true);
    setform((prev) => ({
      ...prev,
      branch_id: item.branchId,
      chit_no: item.temporaryChittyNo,
      branch_name: item.branchName,
      pattern: `${item.subscriptionAmount}X${item.noOfInstallments}`,
    }));
  };
  const handleClose = () => {
    setVisible(false);
    setform(initialValue);
  };
  const handleErrors = (name, message) => {
    setErrors((prev) => ({ ...prev, [name]: message }));
  };

  const handleChange = useCallback((value, name) => {
    let updatedValue = value;
    if (["sala", "denomination"].includes(name)) {
      updatedValue = preventFirstLetterZero(isNaN(value) ? "" : value);
      if (updatedValue.length > 10) return;
    }
    setSearchform((prev) => ({ ...prev, [name]: updatedValue }));
    switch (name) {
      case "sala":
        handleErrors(
          name,
          updatedValue === ""
            ? ""
            : updatedValue >= 50000
            ? ""
            : "Please enter minimum 50000"
        );
        break;
      case "denomination":
        handleErrors(
          name,
          updatedValue === ""
            ? ""
            : updatedValue.length > 3
            ? ""
            : "Please enter minimum 1000"
        );
        break;
      case "district":
        handleErrors(name, updatedValue ? "" : "Please select district");
        setSearchform((prev) => ({
          ...prev,
          district: updatedValue,
          branch_id: "",
          branch_name: "",
        }));
        break;
      default:
        break;
    }
  }, []);

  const getDistrictsList = useCallback(async () => {
    try {
      const res = await ManageApis(
        "get",
        global.listdistricts,
        "",
        is_unregister_user ? quickToken : token
      );
      if (res.response_data?.status) {
        setDistrictList(res.response_data.data.docs);
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    getDistrictsList();
  }, [getDistrictsList]);

  const getNewChitsDetails = async () => {
    try {
      setButtonDisable(true);
      setloader(true);
      const { district, branch_id, sala, denomination, noOfInstallments } =
        searchForm;
        
      const param = {
        is_multi_division: checked,
        district,
        ...(branch_id && { branch_id: Number(branch_id) }),
        ...(sala && { sala: Number(sala) }),
        ...(denomination && { denomination: Number(denomination) }),
        ...(noOfInstallments && { duration: Number(noOfInstallments) }),
      };

      const response = await ManageApis(
        "post",
        global.getNewChit,
        param,
        is_unregister_user ? quickToken : token
      );

      if (response.message === "Success" && response.response_data.status) {
        setList(response.response_data.data.docs || []);
      } else {
        setList([]);
        FailedPopup(response.message);
      }
    } catch (error) {
      FailedPopup(error?.message);
    } finally {
      setloader(false);
      setButtonDisable(false);
    }
  };

  const searchButtonDisabled = useMemo(() => {
    const { district, sala, denomination, noOfInstallments, branch_id } =
      searchForm;
    if (!district) return true;
    const otherFilters = [
      sala,
      denomination,
      noOfInstallments,
      branch_id,
    ].filter(Boolean);
    const hasErrors = Object.values(Errors).some((msg) => msg && msg !== "");
    return otherFilters.length < 1 || hasErrors;
  }, [searchForm, Errors]);

  const handleClear = () => {
    setList([]);
    setSearchform(initialFormValue);
    setErrors({});
    setChecked(false);
  };

  const TableColumn = useMemo(() => {
    const columns = [
      {
        title: "Branch",
        dataIndex: "",
        width: 200,
        render: (v, rec) => rec.branchName,
      },
      {
        title: (
          <>
            <span>Pattern</span>
            <span className="d-flex font_10 fw-normal">
              (Subscription X Duration)
            </span>
          </>
        ),
        dataIndex: "",
        width: 140,
        render: (v, rec) =>
          `${rec.subscriptionAmount || "-"} X ${rec.noOfInstallments || "-"}`,
      },
      {
        title: "Sala",
        dataIndex: "",
        width: 100,
        render: (v, rec) => convertToLakhOrCrore(rec.sala),
        // bodyCellStyle: { textAlign: "right" },
        align: "right",
      },
      {
        title: "Multidivision",
        dataIndex: "",
        width: 120,
        render: (v, rec) => (rec.isMultiDivision ? "Yes" : "No"),
      },
      {
        title: "Chit No",
        dataIndex: "",
        width: 160,
        render: (v, rec) => rec.temporaryChittyNo,
      },
      // {
      //   title: "Chit Frequency",
      //   dataIndex: "",
      //   width: 160,
      //   render: (v, rec) => rec.chittyFrequency,
      // },
      {
        title: "Date Of Announcement",
        dataIndex: "",
        width: 140,
        render: (v, rec) => rec.dateOfAnnouncement,
      },
      {
        title: "Proposed Date Of Commencement",
        dataIndex: "",
        width: 160,
        render: (v, rec) => rec.proposedDateofCommencement,
      },

      {
        title: "Class",
        dataIndex: "",
        width: 80,
        render: (v, rec) => rec.chittyClass,
      },
      {
        title: "Division",
        dataIndex: "",
        width: 90,
        render: (v, rec) => rec.noOfDivisions,
      },
      {
        title: "Status",
        dataIndex: "",
        render: (v, rec) => rec.status.replace("_", " "),
        width: 180,
      },
      {
        title: "GO Date",
        dataIndex: "",
        width: 130,
        render: (v, rec) => (rec.goDate ? rec.goDate : "N/A"),
      },
      {
        title: "GO No",
        dataIndex: "",
        width: 130,
        render: (v, rec) => (rec.goNo ? rec.goNo : "N/A"),
      },
      {
        title: "Action",
        dataIndex: "action",
        fixed: "right",
        width: 150,
        render: (v, rec) =>
          loader ? (
            <Skeleton text={{ rows: 1, width: 100 }} />
          ) : (
            <div className="d-flex justify-content-start">
              {rec.requestSubmittedStatus ? (
                <div className="badge badge_success_soft font_12 fw_500 py-2">
                  Interest Sent
                </div>
              ) : (
                <button
                  className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100 text-nowrap px-1"
                  onClick={() => handleOpenModal(rec)}
                >
                  Express Interest
                </button>
              )}
            </div>
          ),
      },
    ];

    if (list.some((rec) => rec.isMultiDivision)) {
      columns.splice(
        12,
        0, // Insert at the desired position
        {
          title: "No of Lots",
          dataIndex: "",
          width: 100,
          render: (v, rec) => (rec.isMultiDivision ? rec.noOfLots : "N/A"),
        },
        {
          title: "No of Auctions",
          dataIndex: "",
          width: 100,
          render: (v, rec) => (rec.isMultiDivision ? rec.noOfAuctions : "N/A"),
        }
      );
    }

    return columns;
  }, [loader, list]);

  const handleExpressIntrest = async () => {
    //if (form.message) {
    setloader(true);
    const reqstBody = form;
    customLogger("reqstBody--------", reqstBody);
    //debugger
    let response = await ManageApis(
      "post",
      global.expressUserInterest,
      reqstBody,
      is_unregister_user ? quickToken : token
    )
      .then((res) => {
        customLogger("express interest api resp", res);
        const { status, data, message } = res.response_data;

        if (status) {
          // getNewChitsDetails();
          // setform(initialValue);
          setVisible(false);
          setloader(false);
          if (data?.newRequest) {
            successPopup(message);
          } else {
            FailedPopup(message);
          }
          getNewChitsDetails();
        } else {
          FailedPopup(message);
          setloader(false);
          setVisible(true);
        }
      })
      .catch((err) => {
        setloader(false);
        FailedPopup(response);
      });

    // } else {
    //   if (!form.message) {
    //     FailedPopup('Please enter message')
    //     return
    //   }
    // }
  };

  const renderContent = () => (
    <div className="bd_gray border custom_scroll1 overflow-auto pb-4 pt-3 px-3 br_10">
      <div className="">
        <div className="row">
          <GridColumn>
            <InputField
              type="select"
              label="District"
              options={districts}
              placeholder="Choose district"
              onchange={(val) => handleChange(val, "district")}
              value={searchForm.district}
              errorMessage={Errors.district}
              required
              onsearchSearchinputchange={(e) => {
                setSearchInputvalue(preventSpecialCharsandNum(e));
              }}
              searchInputvalue={searchInputvalue}
            />
          </GridColumn>

          {searchForm.district && (
            <>
              <GridColumn>
                <BranchList
                  onChange={(val) => handleChange(val, "branch_id")}
                  selectedItemString={(val) => handleChange(val, "branch_name")}
                  value={searchForm.branch_id}
                  apiParam={`district=${searchForm.district}`}
                  is_unregister_user={is_unregister_user || false}
                />
              </GridColumn>
              <GridColumn>
                <InputField
                  label="Sala Amount"
                  name="sala"
                  type="number"
                  onchange={(val) => handleChange(val, "sala")}
                  value={searchForm.sala}
                  errorMessage={Errors.sala}
                />
              </GridColumn>
              <GridColumn>
                <InputField
                  label="Subscription Amount"
                  name="denomination"
                  type="number"
                  onchange={(val) => handleChange(val, "denomination")}
                  value={searchForm.denomination}
                  errorMessage={Errors.denomination}
                />
              </GridColumn>

              <GridColumn>
                <InputField
                  type="select"
                  label="Duration"
                  options={[25, 30, 40, 50, 60, 80, 100, 120].map((v) => ({
                    key: v,
                    value: v,
                  }))}
                  onchange={(val) => handleChange(val, "noOfInstallments")}
                  value={searchForm.noOfInstallments}
                />
              </GridColumn>
              <GridColumn
                isLastCol
                isButtondisabled={searchButtonDisabled || buttonDisable}
                handleSearch={getNewChitsDetails}
                list={list}
                handleClear={handleClear}
              >
                <div className="align-items-md-center d-flex mt-md-3 flex-wrap">
                  <input
                    type="checkbox"
                    name="multidivision"
                    className="font_18 form-check-input me-2 mt-1"
                    onChange={toggleCheckbox}
                    checked={checked}
                  />
                  <span
                    onClick={toggleCheckbox}
                    className="font_14 fw_500 mt-1 text_master cursor-pointer"
                  >
                    Multidivision
                  </span>
                </div>
              </GridColumn>
            </>
          )}
        </div>
      </div>

      <div className="mt-3 border-top pt-3">
        {list.length > 0 ? (
          <div className="arco_table1 table-responsive custom_scroll1">
            <Table
              columns={TableColumn}
              data={list}
              pagination={false}
              //onChange={handleChangeTable}
              borderCell
              scroll={{
                x: 2300,
                y: 400,
              }}
            />
          </div>
        ) : (
          <div className="p-3 bg-white br_10 shadow_sm">
            <div className="d-flex">
              <div className="m-auto">
                <div className="text-center d-grid py-5 text_gray7">
                  <i className="far fa-file-alt font_18"></i>
                  <p className="mb-0 mt-2">No Chits Found</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {visible && (
        <PopupModal
          title="Express Interest"
          size="md"
          handleClose={handleClose}
          visible={visible}
        >
          <div>
            <div className="mb-3">
              <InputField
                label={"Enter your message"}
                placeholder={"Enter Here"}
                type={"textarea"}
                onchange={(text) =>
                  setform((prev) => ({
                    ...prev,
                    message: text.slice(0, 250),
                  }))
                }
                value={form.message}
                rows={6}
              />
            </div>
            <div>
              <button
                className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100"
                onClick={handleExpressIntrest}
              >
                Submit
              </button>
            </div>
          </div>
        </PopupModal>
      )}
    </div>
  );

  return (
    <>
      <Spin loading={loader} className="w-100 h-100">
        {renderContent()}
      </Spin>
    </>
  );
}

export default NewChits;

const GridColumn = ({
  children,
  isLastCol,
  isButtondisabled,
  handleSearch,
  list,
  isSecondCol,
  handleClear,
}) => (
  <>
    <div className="col-12 col-md-6 col-lg-4">
      <div className="d-flex align-items-end w-100">
        <div className="flex-fill">{children}</div>
      </div>
    </div>
    {isLastCol && children && (
      <div className="col-12 col-lg-4 col-md-6 mt-3 mt-md-0 pt-1">
        <div className="d-flex gap-3 justify-content-end">
          {list.length > 0 && (
            <Button
              className="btn px_btn btn-master-line px-4 rounded fw_500 font_12 w-100"
              disabled={isButtondisabled}
              onClick={handleClear}
            >
              Clear All
            </Button>
          )}
          <GeneralButton
            disabled={isButtondisabled}
            onClick={handleSearch}
            title={"Search"}
          />
        </div>
      </div>
    )}
  </>
);
